import React, { useEffect, useState } from 'react';
import { Link, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import SustainabilityExplorer from './components/SustainabilityExplorer';
import AdminConsole from './components/AdminConsole';
import ReportsAudit from './components/ReportsAudit';
import MyWorkProfile from './components/MyWorkProfile';
import AccessOnboarding from './components/AccessOnboarding';

function TopNav() {
  const location = useLocation();
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  const navLink = (to, label) => (
    <Link
      to={to}
      className={`px-4 py-2 rounded-lg transition-all duration-300 hover:shadow-md hover:scale-[1.02] ${location.pathname === to ? 'bg-blue-600 text-white' : 'bg-white text-gray-800 border border-gray-200'}`}
    >
      {label}
    </Link>
  );

  const onSubmit = (e) => {
    e.preventDefault();
    navigate(`/reports?search=${encodeURIComponent(query)}`);
  };

  return (
    <header className="sticky top-0 z-40 bg-white/80 backdrop-blur supports-[backdrop-filter]:bg-white/60 border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-3">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2 pr-4">
            <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-blue-600 to-indigo-600 shadow-xl shadow-gray-200/50 flex items-center justify-center text-white font-bold">SE</div>
            <span className="text-xl md:text-2xl font-extrabold tracking-tight text-slate-900">Sustainability Command Center</span>
          </div>
          <nav className="hidden md:flex items-center gap-2 ml-4">
            {navLink('/explorer','Explorer')}
            {navLink('/admin','Admin')}
            {navLink('/reports','Reports & Audit')}
            {navLink('/work','My Work')}
          </nav>
          <div className="ml-auto flex items-center gap-3">
            <form onSubmit={onSubmit} className="hidden sm:flex items-center gap-2">
              <input
                value={query}
                onChange={(e)=>setQuery(e.target.value)}
                placeholder="Universal search…"
                className="w-56 md:w-72 bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
              />
              <button type="submit" className="px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all">Search</button>
            </form>
            <Link to="/access" className="px-3 py-2 bg-gray-100 border border-gray-200 rounded-lg hover:bg-gray-200 transition-all">Access</Link>
          </div>
        </div>
        <div className="mt-3 md:hidden flex gap-2 overflow-x-auto pb-2">
          {navLink('/explorer','Explorer')}
          {navLink('/admin','Admin')}
          {navLink('/reports','Reports & Audit')}
          {navLink('/work','My Work')}
        </div>
      </div>
    </header>
  );
}

export default function App(){
  useEffect(()=>{
    document.body.className = 'bg-gray-50 text-gray-900 min-h-screen antialiased';
  },[]);

  return (
    <div className="bg-gray-50 text-gray-900 min-h-screen">
      <TopNav />
      <main className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-6">
        <Routes>
          <Route path="/" element={<SustainabilityExplorer />} />
          <Route path="/explorer" element={<SustainabilityExplorer />} />
          <Route path="/admin" element={<AdminConsole />} />
          <Route path="/reports" element={<ReportsAudit />} />
          <Route path="/work" element={<MyWorkProfile />} />
          <Route path="/access" element={<AccessOnboarding />} />
        </Routes>
      </main>
      <footer className="mt-10 py-6 text-center text-sm text-gray-600">© 2026 Sustainability Command Center — Demo UI</footer>
    </div>
  );
}
